import { Button } from "../components/Button";
import { Dialog, DialogClose, DialogContent } from "../components/Dialog";
import { Spinner } from "../components/Spinner";
import { ArrowDownOnSquareIcon, ChevronLeftIcon, ChevronRightIcon, XMarkIcon, } from "../icons/app";
import { cn } from "../lib/utils";
import React, { useCallback, useState } from "react";
function downloadFile(url, filename) {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
function ImageZoomDialog({ open, onOpenChange, image, navigation, }) {
    var _a;
    const [imageLoaded, setImageLoaded] = useState(false);
    const handleDownload = useCallback((e) => {
        e.stopPropagation();
        if (image.downloadUrl && image.title) {
            downloadFile(image.downloadUrl, image.title);
        }
    }, [image.downloadUrl, image.title]);
    // Reset image loaded state when dialog closes or image changes
    React.useEffect(() => {
        setImageLoaded(false);
    }, [open, image.src]);
    return (React.createElement(Dialog, { open: open, onOpenChange: onOpenChange },
        React.createElement(DialogContent, { size: "fit", className: "s-overflow-hidden s-p-3" },
            React.createElement("div", { className: "s-relative s-flex s-items-center s-justify-center s-gap-2" },
                (navigation === null || navigation === void 0 ? void 0 : navigation.hasPrevious) && (React.createElement(Button, { variant: "ghost", size: "sm", icon: ChevronLeftIcon, onClick: (e) => {
                        e.stopPropagation();
                        navigation.onPrevious();
                    } })),
                React.createElement("div", { className: "s-relative s-rounded s-overflow-hidden" }, image.isLoading ? (React.createElement("div", { className: cn("s-mx-auto s-flex s-aspect-square s-w-full s-min-w-[50vh]", "s-max-w-[80vh] s-items-center s-justify-center", "s-bg-muted-background dark:s-bg-muted-background-night") },
                    React.createElement(Spinner, { variant: "dark", size: "lg" }))) : (React.createElement(React.Fragment, null,
                    React.createElement("img", { src: image.src, alt: (_a = image.alt) !== null && _a !== void 0 ? _a : "", className: "s-max-h-full s-max-w-full s-object-contain", onLoad: () => setImageLoaded(true) }),
                    React.createElement(DialogClose, { asChild: true },
                        React.createElement(Button, { variant: "outline", size: "xs", icon: XMarkIcon, className: "s-absolute s-right-2 s-top-2" })),
                    imageLoaded && image.downloadUrl && (React.createElement(Button, { variant: "outline", size: "xs", icon: ArrowDownOnSquareIcon, tooltip: "Download", className: "s-absolute s-bottom-2 s-right-2", onClick: handleDownload }))))),
                (navigation === null || navigation === void 0 ? void 0 : navigation.hasNext) && (React.createElement(Button, { variant: "ghost", size: "sm", icon: ChevronRightIcon, onClick: (e) => {
                        e.stopPropagation();
                        navigation.onNext();
                    } }))))));
}
ImageZoomDialog.displayName = "ImageZoomDialog";
export { downloadFile, ImageZoomDialog };
//# sourceMappingURL=ImageZoomDialog.js.map